import { formatDate } from '@angular/common';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
    AndroidDeviceOwnerCompliancePolicy,
    AppListItem,
    DeviceCompliancePolicyAssignment,
} from '@microsoft/microsoft-graph-types-beta';
import { BaseComponent } from '../../../../base/base.component';
import * as AndroidCompliancePolicyHelper from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/compliance-policies/android-compliance-policy';
import { initForm } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/compliance-policies/android-compliance-policy';
import { AndroidCompliancePolicySchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/compliance-policies/android-compliance-policy/model';
import { PolicyAssignment } from 'projects/angular-clarity/src/app/stores/client/graph/intune/compliance-policies/policies/model';

@Component({
    selector: 'app-baseline',
    templateUrl: './baseline.component.html',
    styleUrls: ['./baseline.component.scss', '../../../../styles/baseline-style.scss'],
})
export class BaselineComponent extends BaseComponent implements OnInit, OnChanges {
    errorString = ''; // string contains all errors
    tooltips = AndroidCompliancePolicyHelper.tooltips;
    form: FormGroup; // undefined
    formErrors;

    @Input() data: PolicyAssignment<AndroidDeviceOwnerCompliancePolicy>[];

    policy: AndroidDeviceOwnerCompliancePolicy;
    assignments: DeviceCompliancePolicyAssignment[] = [];

    loaded: boolean;

    constructor(private fb: FormBuilder) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.loadData();
        this.setErrorString();
    }

    ngOnInit(): void {
        this.loadData();
        this.setErrorString();

        this.form = initForm(this.baseline.schema, this.fb);
        this.loaded = true;

        this.observeForm();
    }

    setErrorString(): void {
        this.errorString = '';
        this.errors.forEach((res) => {
            this.errorString += '!' + res.instancePath + '!';
        });
    }

    loadData(): void {
        const displayName = this.baseline.schema.contains.properties.policy.properties.displayName?.const;
        const policy_assignments = this.data.find((res) => res?.policy?.displayName === displayName);
        this.policy = policy_assignments?.policy;
        console.log('policy:', this.policy);
        console.log('data:', this.data);
        this.assignments = policy_assignments?.assignments || [];

        this.setErrorString();
    }

    observeForm() {
        const schema: AndroidCompliancePolicySchema = JSON.parse(JSON.stringify(this.baseline.schema));

        this.form.valueChanges.subscribe((res) => {
            const updatedSchema = AndroidCompliancePolicyHelper.updateSchema(this.formValue, schema);

            console.log(updatedSchema, 'schema');
            const formHasError = Object.keys(this.form.controls).some((control) => this.form.get(control).invalid);

            const nowGroupAssignments = updatedSchema.contains.properties.assignments?.maxItems === 0;

            this.formErrors = formHasError || nowGroupAssignments;

            if (this.formErrors) {
                this.baselineErrorChange.next({ remediate: true, save: true });
            } else {
                this.baselineErrorChange.next({ remediate: false, save: false });
            }

            this.setErrorString();

            this.baselineChange.next({
                ...this.baseline,
                schema: JSON.parse(JSON.stringify(updatedSchema)),
            });
        });
    }

    convertMinuteToString(minutes: number): string {
        if (minutes === 0) {
            return 'Not configured';
        } else if (minutes < 60) {
            return `${minutes} minutes`;
        } else {
            return `${minutes / 60} hours`;
        }
    }

    onMinPatchDateChange(date: Date) {
        if (date) {
            const formatted = formatDate(date, 'yyyy-MM-dd', 'en-US');
            this.form.get('minAndroidSecurityPatchLevel')?.setValue(formatted);
        }
    }

    markFormAsDirty(): void {
        this.form.markAsDirty();
        this.form.markAllAsTouched();
    }

    addRestrictedAppRow(): void {
        const newItem = this.addRestrictedApp();
        (this.form.get('restrictedApps') as FormArray).push(newItem);
    }

    addRestrictedApp(item?: AppListItem): FormGroup {
        return this.fb.group({
            name: [item?.name, [Validators.required]],
            appId: [item?.appId, [Validators.required]],
        });
    }

    removeRestrictedAppRow(index: number): void {
        (this.form.get('restrictedApps') as FormArray).removeAt(index);
    }

    get formValue() {
        return this.form.getRawValue();
    }

    get passwordRequired() {
        return this.formValue.passwordRequired;
    }

    get assignmentsValue() {
        return this.formValue.assignments;
    }

    get restrictedAppsControls() {
        return (this.form.get('restrictedApps') as FormArray).controls;
    }
}
